import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  map: generateApiPath({ prefix: AuthLevel.PUBLIC, name: 'map' }),
}

export { paths }
